import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

import CopyToClipboard from "./CopyToClipboard";
import { Sizes } from "./Icon";
import NoData from "./NoData";

type Props = {
  value?: string | null;
  reverse?: boolean;
  size?: Sizes;
  className?: string;
  dataTestId?: string;
};

const StringWithCopy: FC<PropsWithChildren<Props>> = ({
  className,
  value,
  reverse,
  size = 14,
  dataTestId = "report_summary_hash_value",
  children
}) => {
  if (!value) return <NoData />;

  return (
    <div
      className={clsx(
        "flex flex-gap-1 overflow-ellipsis k-pdf-hash-info-item",
        className
      )}
    >
      <CopyToClipboard
        containerClassName={clsx("flex", `flex-order-${reverse ? 1 : 0}`)}
        className="k-pdf-hide-in-pdf"
        value={value}
        size={size}
      />
      <div
        className={clsx("overflow-ellipsis", `flex-order-${reverse ? 0 : 1}`)}
        data-testid={dataTestId || undefined}
      >
        {children ?? value}
      </div>
    </div>
  );
};

export default StringWithCopy;
